import throwErrorIfTesting from "@insite/client-framework/Common/ThrowErrorIfTesting";
import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnSuccess,
    makeHandlerChainAwaitable,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { AddProductApiParameter } from "@insite/client-framework/Services/CartService";
import loadCurrentPromotions from "@insite/client-framework/Store/Data/Promotions/Handlers/LoadCurrentPromotions";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";
import loadCurrentCart from "@waytek/Handlers/Carts/LoadCurrentCart";
import { addProductWithResult } from "@waytek/Services/CartService";
import { CustomState } from "@waytek/Store/Reducers";

type AddToCartParameter = {
    onError?: (error: string) => void;
} & AddProductApiParameter &
    HasOnSuccess<CartLineModel>;

type HandlerType = ApiHandler<AddToCartParameter & { loadCart?: boolean }, CartLineModel>;

export const PopulateApiParameter: HandlerType = props => {
    throwErrorIfTesting();

    props.apiParameter = props.parameter;
};

export const DispatchBeginAddingProductToCart: HandlerType = props => {
    if (props.parameter.loadCart) {
        props.dispatch({
            type: "Context/BeginAddingProductToCart",
        });
    }

    props.dispatch({
        type: "Custom/ProductCartState/MoveQueue",
    } as any);
};

export const VerifyCartUpdates: HandlerType = props => {
    if ((props.getState() as CustomState).customProductCartState.isSaving) {
        return false;
    }
};

export const SendDataToApi: HandlerType = async props => {
    const result = await addProductWithResult(props.apiParameter);
    if (result.successful) {
        props.apiResult = result.result;
    } else {
        if (result.statusCode === 403) {
            const { isAuthenticated, rememberMe } = props.getState().context.session;
            (isAuthenticated || rememberMe) && window.location.reload();
            return false;
        }

        props.parameter.onError?.(result.errorMessage);
        return false;
    }
};

export const DispatchCompleteAddingProductToCart: HandlerType = props => {
    if (props.parameter.loadCart) {
        props.dispatch({
            type: "Context/CompleteAddingProductToCart",
        });
    }

    props.dispatch({
        type: "Custom/ProductCartState/Remove",
        id: props.apiParameter.productId,
        apiType: 1,
    } as any);
};

export const LoadCart: HandlerType = async props => {
    if (props.parameter.loadCart) {
        const awaitableLoadCurrentCart = makeHandlerChainAwaitable(loadCurrentCart);
        await awaitableLoadCurrentCart({})(props.dispatch, props.getState);
    }
};

// export const LoadPromotions: HandlerType = props => {
//     props.dispatch(loadCurrentPromotions());
// };

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.parameter.loadCart) {
        markSkipOnCompleteIfOnSuccessIsSet(props);
    }
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [
    VerifyCartUpdates,
    PopulateApiParameter,
    DispatchBeginAddingProductToCart,
    SendDataToApi,
    LoadCart,
    // LoadPromotions,
    DispatchCompleteAddingProductToCart,
    ExecuteOnSuccessCallback,
];

const addToCart = createHandlerChainRunner(chain, "AddToCart");
export default addToCart;
